<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- MOBILE VIEW (Fintech Style) -->
    <div class="content d-lg-none mob-pendamping-list">
        <!-- Header & Search -->
        <div class="px-2 mb-4">
           <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-3">
                 <a href="javascript:void(0);" @click="router.push('/dashboard')" class="btn-back-mob shadow-sm">
                    <vue-feather type="arrow-left" size="20"></vue-feather>
                 </a>
                 <h4 class="fw-bold mb-0">Petugas Pendamping</h4>
              </div>
              <button v-if="$hasPermission('ssp', 'pendampings', 'create')" @click="openAddModal" class="btn btn-success-circle shadow-sm">
                 <vue-feather type="plus" size="20"></vue-feather>
              </button>
           </div>
           
           <div class="search-input-mob shadow-xs">
              <vue-feather type="search" size="18" class="text-muted"></vue-feather>
              <input type="text" v-model="searchQuery" placeholder="Cari Petugas..." class="border-0 bg-transparent w-100 ms-2" />
           </div>
        </div>

        <!-- Pendamping List Cards -->
        <div class="px-2 pb-5">
           <div v-if="filteredPendamping.length > 0">
              <div 
                v-for="petugas in filteredPendamping" 
                :key="'mob-pet-'+petugas.id" 
                class="mob-pendamping-card mb-3 p-0 bg-white"
              >
                 <div class="px-3 pt-3 pb-2 d-flex justify-content-between align-items-center">
                    <span class="badge rounded-pill smallest px-2 py-1 uppercase" :class="petugas.status === 'active' ? 'bg-success-soft text-success' : 'bg-light text-muted'">{{ petugas.status === 'active' ? 'AKTIF' : 'NON-AKTIF' }}</span>
                    <div class="d-flex gap-2">
                       <button v-if="$hasPermission('ssp', 'pendampings', 'edit')" @click="openEditModal(petugas)" class="btn-action-lite text-primary">
                          <vue-feather type="edit-3" size="14"></vue-feather>
                       </button>
                       <button v-if="$hasPermission('ssp', 'pendampings', 'delete')" @click="showConfirmation(petugas.id)" class="btn-action-lite text-danger">
                          <vue-feather type="trash-2" size="14"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- Officer Info -->
                 <div class="px-3 pb-3">
                    <h6 class="fw-bold text-dark mb-0 text-uppercase">{{ petugas.nama_pendamping }}</h6>
                 </div>
              </div>
           </div>
           
           <!-- Empty State Mobile -->
           <div v-else class="text-center py-5">
              <div class="bg-light p-4 rounded-circle d-inline-block mb-3">
                 <vue-feather type="users" class="text-muted" size="40"></vue-feather>
              </div>
              <p class="text-muted small">Tidak ada data Petugas ditemukan.</p>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW (Untouched) -->
    <div class="content d-none d-lg-block">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Petugas Pendamping</h4>
            <h6>Kelola Petugas Pendamping Anda</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              id="collapse-header"
              ><i data-feather="chevron-up" class="feather-chevron-up"></i
            ></a>
          </li>
        </ul>
        <div v-if="$hasPermission('ssp', 'pendampings', 'create')" class="page-btn">
          <button
            @click="openAddModal"
            class="btn btn-added"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Tambah Petugas</button
          >
        </div>
      </div>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input 
                  type="text" 
                  placeholder="Cari Petugas..." 
                  class="dark-input" 
                  v-model="searchQuery"
                />
                <a href="javascript:void(0);" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
            <div class="search-path d-none d-md-block">
              <a
                class="btn btn-filter"
                id="filter_search"
                v-on:click="filter = !filter"
                :class="{ setclose: filter }"
              >
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
              </a>
            </div>
            <div class="form-sort d-none d-md-flex">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select 
                :options="SortOptions" 
                v-model="sortOrder" 
                placeholder="Urutkan" 
                @select="sortOrder = $event.value"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card mb-0"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-3">
              <div class="row align-items-center">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <vue-feather type="stop-circle" class="info-img"></vue-feather>
                    <vue-select
                      :options="StatusFilterOptions"
                      v-model="statusFilter"
                      placeholder="Pilih Status"
                      @select="statusFilter = $event.value"
                    />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <a class="btn btn-filters" @click="resetFilters">
                      <vue-feather type="rotate-ccw" class="me-1" style="width: 14px;"></vue-feather>
                      Reset
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive product-list">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredPendamping"
              :loading="loading"
              :pagination="{
                pageSize: 5,
                showSizeChanger: false,
                position: ['bottomRight']
              }"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Petugas'">
                  <a href="javascript:void(0);">{{ record.nama_pendamping }} </a>
                </template>

                <template v-else-if="column.key === 'status'">
                  <span class="badge" :class="record.status === 'active' ? 'badge-success' : 'badge-danger'">
                    {{ record.status === 'active' ? 'Aktif' : 'Non-Aktif' }}
                  </span>
                </template>

                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a 
                        v-if="$hasPermission('ssp', 'pendampings', 'edit')"
                        class="me-2 p-2" 
                        href="javascript:void(0);"
                        @click="openEditModal(record)"
                      >
                        <vue-feather type="edit" class="feather-edit"></vue-feather>
                      </a>
                      <a
                        v-if="$hasPermission('ssp', 'pendampings', 'delete')"
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <vue-feather type="trash-2" class="trash-2"></vue-feather>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <edit-pendamping-modal :pendamping="selectedPendamping"></edit-pendamping-modal>
  <add-pendamping-modal></add-pendamping-modal>
</template>
<script>
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
import { useDataStore } from "@/store/dataStore";
import pendampingService from "@/services/pendampingService";
import EditPendampingModal from "@/components/modal/edit-pendamping-modal.vue";
import AddPendampingModal from "@/components/modal/add-pendamping-modal.vue";
import Swal from "sweetalert2";

    const displayColumns = computed(() => {
      const baseColumns = [
        {
          title: "Nama Petugas",
          dataIndex: "nama_pendamping",
          key: "Petugas",
          sorter: {
            compare: (a, b) => a.nama_pendamping.localeCompare(b.nama_pendamping),
          },
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          sorter: {
            compare: (a, b) => a.status.localeCompare(b.status),
          },
        },
      ];

      const userStr = localStorage.getItem('currentUser');
      const user = userStr ? JSON.parse(userStr) : null;
      const isAdmin = user?.role === 'admin';
      const perms = user?.permissions?.ssp?.pendampings || [];
      
      if (isAdmin || perms.includes('edit') || perms.includes('delete')) {
        baseColumns.push({
          title: "Aksi",
          key: "action",
        });
      }
      
      return baseColumns;
    });

export default {
  components: {
    EditPendampingModal,
    AddPendampingModal
  },
  setup() {
    const router = useRouter();
    const filter = ref(false);
    const searchQuery = ref("");
    const selectedPendamping = ref({});
    const statusFilter = ref(null);
    const sortOrder = ref("ASC");
    
    const { pendampings, state, refreshData } = useDataStore();
    const loading = computed(() => state.isLoading && pendampings.value.length === 0);

    const openAddModal = () => {
       const btn = document.createElement('button');
       btn.setAttribute('data-bs-toggle', 'modal');
       btn.setAttribute('data-bs-target', '#add-pendamping-modal');
       document.body.appendChild(btn);
       btn.click();
       document.body.removeChild(btn);
    };

    const openEditModal = (petugas) => {
       selectedPendamping.value = { ...petugas };
       setTimeout(() => {
          const btn = document.createElement('button');
          btn.setAttribute('data-bs-toggle', 'modal');
          btn.setAttribute('data-bs-target', '#edit-pendamping-modal');
          document.body.appendChild(btn);
          btn.click();
          document.body.removeChild(btn);
       }, 50);
    };

    // Pencarian realtime di sisi client
    const filteredPendamping = computed(() => {
      let result = [...pendampings.value];

      // 1. Search Query
      if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase();
        result = result.filter(item => 
          item.nama_pendamping.toLowerCase().includes(query) ||
          (item.id && item.id.toString().includes(query)) ||
          (item.nomor_handphone && item.nomor_handphone.includes(query))
        );
      }

      // 2. Status Filter
      if (statusFilter.value) {
        result = result.filter(item => item.status === statusFilter.value);
      }

      // 3. Sorting
      result.sort((a, b) => {
        const nameA = (a.nama_pendamping || "").toLowerCase();
        const nameB = (b.nama_pendamping || "").toLowerCase();
        if (sortOrder.value === "ASC") {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      return result;
    });

    const resetFilters = () => {
      statusFilter.value = null;
      searchQuery.value = "";
    };

    const showConfirmation = (id) => {
      Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Data yang dihapus tidak dapat dikembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Batal",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await pendampingService.deletePendamping(id);
            Swal.fire({
              icon: "success",
              title: "Berhasil Dihapus!",
              text: "Petugas telah berhasil dihapus.",
              confirmButtonClass: "btn btn-success",
            });
            refreshData('pendampings');
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: "Gagal menghapus petugas dari server",
              confirmButtonClass: "btn btn-danger",
            });
          }
        }
      });
    };

    return {
      filter,
      loading,
      filteredPendamping,
      searchQuery,
      selectedPendamping,
      columns: displayColumns,
      showConfirmation,
      resetFilters,
      statusFilter,
      sortOrder,
      router,
      openAddModal,
      openEditModal,
      SortOptions: [
        { id: 'ASC', value: 'ASC', text: 'ASC (A-Z)' },
        { id: 'DESC', value: 'DESC', text: 'DESC (Z-A)' }
      ],
      StatusFilterOptions: [
        { id: 'active', value: 'active', text: 'Aktif' },
        { id: 'inactive', value: 'inactive', text: 'Tidak Aktif' }
      ]
    };
  },
};
</script>

<style scoped>
/* Mobile Pendamping List Styles */
.mob-pendamping-list {
  padding-top: 15px !important;
  background: #fdfdfd;
}

.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}
.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.btn-success-circle {
  width: 44px;
  height: 44px;
  background: #029147;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.search-input-mob {
  background: white;
  padding: 12px 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f5f9;
}

.mob-pendamping-card {
  background: white;
  border-radius: 20px;
  border: none !important;
  box-shadow: 0 8px 20px rgba(0,0,0,0.05);
  overflow: hidden;
  transition: all 0.2s ease;
}

.mob-pendamping-card:active { 
  transform: translateY(2px) scale(0.98); 
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
}

.btn-action-lite {
  background: #f8fafc;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-action-lite:active { transform: scale(0.9); }

.bg-success-soft { background: #ecfdf5; }

.uppercase { text-transform: uppercase; letter-spacing: 0.5px; }
.smallest { font-size: 10px; }

.btn-added {
    background-color: #000;
    color: #fff;
    border-radius: 8px;
    font-weight: bold;
}
.btn-added:hover {
    background-color: #333;
    color: #fff;
}

@media (max-width: 991.98px) {
  .page-header { display: none !important; }
}
</style>
